// Slide copy for the signup brand panel carousels.

export type SignupAgentSlide =
  | { graphic: "miniapps" }
  | {
      title: string;
      description: string;
      graphic:
        | "integrations"
        | "context"
        | "domains"
        | "selectEdit"
        | "insights";
    };

export type SignupShopifySlide = {
  title: string;
  description: string;
  graphic: "editor" | "templates" | "content" | "publish";
};

export const signupAgentSlides: SignupAgentSlide[] = [
  { graphic: "miniapps" },
  {
    title: "Connect your store stack",
    description:
      "Bring store data, campaign signals, reviews, email, subscriptions, and customer tools into the same flow. ",
    graphic: "integrations",
  },
  {
    title: "Keep product and brand context close",
    description:
      "Give Replo your products, brand notes, images, and files once. Use them across every store update.",
    graphic: "context",
  },
  {
    title: "Launch on your own domain",
    description:
      "Connect the domain your customers know, then publish your storefront where it belongs.",
    graphic: "domains",
  },
  {
    title: "Chat to get the work done",
    description:
      "Ask Replo to accomplish anything across your store, from site edits to connecting integrations or creating products.",
    graphic: "selectEdit",
  },
  {
    title: "Turn data into next steps",
    description:
      "Replo makes sense of store and campaign data, then suggests what to act on next.",
    graphic: "insights",
  },
];

export const signupShopifySlides: SignupShopifySlide[] = [
  {
    title: "Drag-and-drop page builder",
    description:
      "Drop sections into place, then adjust layout, spacing, and styles from the builder panel.",
    graphic: "editor",
  },
  {
    title: "Start from sections and templates",
    description:
      "Use ready-made layouts for landing pages, PDPs, collections, and campaign pages, then customize them for the brand.",
    graphic: "templates",
  },
  {
    title: "Use dynamic Shopify data",
    description:
      "Connect products, images, prices, and reviews with dynamic data so the page stays accurate as Shopify changes.",
    graphic: "content",
  },
  {
    title: "Publish to your Shopify theme",
    description:
      "Send finished pages into the theme your store already uses, with a preview of what will go live before customers see it.",
    graphic: "publish",
  },
];
